// extracted by mini-css-extract-plugin
module.exports = {"river2ProKit":"river2ProKit_river2ProKit__dMlpI"};